import { render } from "./EcoEventsInfo.vue?vue&type=template&id=444673f8&scoped=true"
import script from "./EcoEventsInfo.vue?vue&type=script&lang=js"
export * from "./EcoEventsInfo.vue?vue&type=script&lang=js"

import "./EcoEventsInfo.vue?vue&type=style&index=0&id=444673f8&scoped=true&lang=scss"

import exportComponent from "/opt/tracking-bg-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-444673f8"]])

export default __exports__